import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './circularProgressbar.sass'
import avatar from '../img/avatar.jpg'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
      myAge: 30,
    }
  }
  componentDidMount() {
    const curDate = new Date();
    this.setState({
      myAge: curDate.getFullYear() - 1993,
    });
  }
  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: 'is-active',
          })
          : this.setState({
            navBarActiveClass: '',
          })
      }
    )
  }

  render() {
    return (
      <div className={`art-info-bar ${this.state.navBarActiveClass}`} onClick={() => this.toggleHamburger()}>
        <div className="art-info-bar-frame">
          <div className="art-info-bar-header">
            <a className="art-info-bar-btn"> <i className="fas fa-ellipsis-v"></i> </a>
          </div>
          <div className="art-header">
            <div className="art-avatar">
              
              <a href={avatar} className="art-avatar-curtain">
                <img src={avatar} alt="avatar"/>
                <i className="fas fa-expand"></i>
              </a>
              <div className="art-lamp-light"><div className="art-available-lamp"></div></div>
            </div>
            <h5 className="art-name mb-10"><a href="https://bslthemes.com/arter-wp">Samer Salmeh</a></h5>
            <div className="art-sm-text">Front-end Developer</div>
          </div>
          <div className="art-scroll-frame">
            <div className="art-table">
              <ul>
                <li><h6>Residence:</h6><span>Japan</span></li>
                <li><h6>City:</h6><span>Tokyo</span></li>
                <li><h6>Age:</h6><span>{this.state.myAge}</span></li>
              </ul>
            </div>
            <div className="art-ls-divider"></div>
              <div className="art-about">
                <h6>Who Am I?</h6>
                <p>Front-End Developer with over 5 years of professional experience. I am a good timekeeper, always willing to learn new skills. Able to work independently in busy environments and also within a team setting.  I work with LOVE  and live by challenges.</p>
              </div>
              <div className="art-ls-divider"></div>
            <div className="art-lang-skills">
              <div className="art-lang-skills-item">
                <div className="art-lang-skills-div">
                  <CircularProgressbar value={100} text={`${100}%`} />
                </div>
                <h6>Arabic</h6>
                
              </div>
              <div className="art-lang-skills-item">
                <div className="art-lang-skills-div">
                  <CircularProgressbar value={90} text={`${90}%`} />
                </div>
                <h6>English</h6>
              </div>
              <div className="art-lang-skills-item">
                <div className="art-lang-skills-div">
                  <CircularProgressbar value={75} text={`${75}%`} />
                </div>
                <h6>Japanese</h6>
              </div>
            </div>
            <div className="art-ls-divider"></div>
            <div className="art-links-frame p-15-15">
              <a href="https://drive.google.com/uc?export=download&id=1pa5n2ERxpWlTWN3isN3USIeg0gKnkYvT" className="art-link" target="_blank" rel="noreferrer">Download cv <i className="fas fa-download"></i></a>
            </div>
          </div>
          <div className="art-ls-social">
            <a href="https://www.linkedin.com/in/samersalmeh/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></a>
            {/* <a href="https://dribble.com/" target="_blank" rel="noreferrer"><i className="fab fa-dribbble"></i></a>
            <a href="https://behance.com/" target="_blank" rel="noreferrer"><i className="fab fa-behance"></i></a> */}
            <a href="https://github.com/SamerSalmeh" target="_blank" rel="noreferrer"><i className="fab fa-github"></i></a>
            <a href="https://twitter.com/SalmehSamer" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>
    )
  }
}

export default Navbar
